// extracted by mini-css-extract-plugin
module.exports = {"photoDetail":"detail_photoDetail__1zfjv","photos":"detail_photos__3cRb7","photo":"detail_photo__9Gzbu"};